module.exports = __webpack_public_path__ + "static/media/img-42.dadcebbc.jpg";